<template>
  <div
    :class="[
      'blogs-banner',
      {
        'logged-in': userTokenAvailable && !isMobile,
        'not-logged-in': !userTokenAvailable && isMobile,
        collapsed: this.$root.isCollapsed && !isMobile,
        notification:
          userTokenAvailable &&
          this.$root.warning &&
          this.$root.warning !== 'NORMAL' &&
          !isMobile,
      },
    ]"
  >
    <div
      class="Customcontainer BlogsbannerContainer"
      :style="{ paddingTop: userTokenAvailable && '1rem' }"
    >
      <section class="BlogsBanner">
        <video autoplay loop muted playsinline class="banner-video" >
          <source type="video/webm" :src="getCDNlink('assets/new-assets/Blogs/Blogs_Banner.webm')"/>
          Your browser does not support the video tag.
        </video>
        <div class="BlogsBanner_after container-fluid">
          <div class="BlogbannercontentBox">
            <h2 class="TitleTop">
              The Portside View <br />
            </h2>
            <p class="TitleDetail">
              Investigative insight into business risk
            </p>
            <div class="BlogSearch" v-if="!userTokenAvailable">
              <form @submit.prevent="subscribeNewsLetter">
                <input
                  v-model.trim="email"
                  type="text"
                  class="form-control"
                  :placeholder="$t('email-placeholder')"
                  autocomplete="off"
                />
                <p v-if="errors.email && touched.email" class="error">
                  &nbsp; &nbsp;{{ errors.email }}
                </p>
                <button :disabled="isSubmitting" class="continue_btn">
                  {{ isSubmitting ? "Subscribing..." : $t("Subscribe") }}
                </button>
              </form>
            </div>
            <!-- <p class="TitleDetail">
              By subscribing, you agree to our Privacy Policy
            </p> -->
          </div>
        </div>
      </section>
      <Blogslist />
    </div>
    <Footer class="footer-instance" v-if="!userTokenAvailable"></Footer>
  </div>
  <Toastify ref="toastContainer" />
</template>

<script>
import Footer from "@/components/HomePage/Footer/Footer.vue";
import Blogslist from "@/components/Blogs/BlogsList.vue";
import VueCookies from "vue-cookies";
import { NewsLetter } from "@/api/APIs";
import Toastify from "@/components/Toastify.vue";
import { useI18n } from "vue-i18n";
import config from "@/config";

export default {
  name: "BlogsBanner",
  components: {
    Blogslist,
    Footer,
    Toastify,
  },
  data() {
    return {
      email: "",
      errors: {},
      touched: {},
      isSubmitting: false,
      userToken: null,
      isMobile: window.innerWidth < 1023,
      displayTextArray: [],
    };
  },
  setup() {
    const { locale, t } = useI18n();
    return { locale, t };
  },
  beforeMount() {
    this.userToken = VueCookies.get("token");
  },
  computed: {
    userTokenAvailable() {
      return this.userToken !== null;
    },
  },
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
    async subscribeNewsLetter() {
      if (!this.email) {
        return this.$refs.toastContainer.addToast(
          "Please enter the email to subscribe to our Newsletter.",
          { type: "error" }
        );
      }
      try {
        const response = await NewsLetter(this.email);
        if (response && response?.message == "SUCCESS") {
          return this.$refs.toastContainer.addToast(
            "Thank you for subscribing to our News and Offers! 🎉",
            { type: "success" }
          );
        } else {
          return this.$refs.toastContainer.addToast(
            "You have already subscribed to our Newsletter. Stay tuned for exciting updates! 👍🏻",
            { type: "info" }
          );
        }
      } catch (error) {
        this.emailError = "Something went wrong! Please try again.";
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.blogs-banner {
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.logged-in {
  margin-left: 18vw;
  transition: margin-left 0.3s ease;
}
.logged-in.collapsed {
  margin-left: 60px;
}
.logged-in.notification {
  padding-top: 105px !important;
}
.not-logged-in {
  width: 100%;
}
.Customcontainer {
  width: 100%;
}
.BlogsBanner {
  position: relative;
  height: 550px;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  /* border-radius: 18px; */
  min-height: 200px;
}
.banner-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* z-index: 1; */
}
.BlogsBanner_after {
  position: relative;
  /* left: 0;
  top: 0; */
  padding: 4rem 0;
  background: linear-gradient(90deg, #0a0f14, #0013269e 50.31%, #11365a00);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: -webkit-fill-available;
}
.BlogbannercontentBox {
  width: 85%;
  /* max-width: 75rem; */
  color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 55px;
}
.TitleTop {
  font-family: "Figtree";
  font-size: 68px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 45px; */
  letter-spacing: -1.44px;
  flex: 1 0 0;
  margin: 0;
  background: var(
    --Home-Banner-Title-Gradient,
    radial-gradient(
      58.47% 140.95% at 31.38% -13.87%,
      #fff 36%,
      #ffece0 64%,
      #72b4ff 88.94%
    )
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
}
.Title {
  color: white;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.44;
  font-family: "Figtree";
  margin: 0;
}
.TitleDetail {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  font-family: "Figtree";
  margin: 0 0 20px 0;
}
.form-control {
  border: none;
  outline: none;
}
.continue_btn {
  background-color: #046BE1;
  color: white;
  padding: 10px 15px;
  outline: none;
  border: none;
  box-shadow: 0 24px 24px 0 rgba(17, 54, 90, 0.2);
  border-radius: 50px;
  height: 100%;
}
.BlogSearch {
  padding: 2px;
  border-radius: 50px;
  background-color: white;
  overflow: hidden;
  width: 40%;
}
input[type="text"] {
  margin: 0;
  box-shadow: none;
  height: 100%;
  width: 60%;
}
form {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.footer-instance {
  flex-shrink: 0 !important;
  width: 100% !important;
}

@media only screen and (max-width: 767px) {
  .BlogsBanner_after {
    padding: 1rem 0;
  }
  /* .TitleTop {
    font-size: 16px;
  } */
  .Title {
    font-size: 20px;
  }
  .TitleTop {
    font-size: 36px;
    line-height: 36px;
  }
  .TitleDetail {
    font-size: 16px;
    text-align: left;
    line-height: 20px;
  }
  .BlogSearch {
    width: 100%;
    margin: 5px 0;
  }
  .continue_btn {
    padding: 5px 8px;
    font-size: 12px;
  }
  .BlogbannercontentBox {
    margin-top: 20px;
  }
  /* .Customcontainer {
    margin-top: 20px;
  } */
}
@media only screen and (min-width: 768px) and (max-width: 1156px) {
  .BlogsBanner_after {
    padding: 2rem 0;
  }
  /* .TitleTop {
    font-size: 20px;
  } */
  .Title {
    font-size: 25px;
  }
  .TitleDetail {
    font-size: 18px;
  }
  .BlogSearch {
    width: 55%;
  }
}
@media only screen and (min-width: 1156px) {
}
</style>
